<template>
  <div>
    <list
      row-key="Id"
      ref="list"
      :page="false"
      :query-params="params"
      :show-checkbox="false"
      :show-query="false"
      :get-data-func="getDataFunc"
    >
      <template slot="toolbar-right">
        <!-- <slot name="toolbar-right"></slot> -->
        <el-button @click="openEdit" type="primary">设置查询方案</el-button>
        <el-button @click="openSelect" type="primary">选择查询方案</el-button>
        <el-button @click="onReset" type="primary" plain>重置查询</el-button>
        <el-button @click="onExport" type="success">导出</el-button>
        <el-button @click="onExportDetail" type="success" plain>导出明细</el-button>
      </template>
      <template slot="query"></template>
      <template slot="table">
        <el-table-column prop="TeacherName" label="姓名">
          <template slot-scope="{row}">
            <el-link :underline="false" style="font-size: 12px;" @click="openAll(row)">
              <span>{{row.TeacherName}}</span>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="YrCount" min-width="120px" label="育人工作记录数量" />
        <el-table-column prop="KcCount" min-width="120px" label="课程教学记录数量" />
        <el-table-column prop="JkCount" min-width="120px" label="教科研记录数量" />
        <el-table-column prop="SfCount" min-width="120px" label="示范引领记录数量" />
        <el-table-column prop="ZdCount" min-width="120px" label="指导学生记录数量" />
        <el-table-column prop="XxCount" min-width="120px" label="学习培训记录数量" />
        <el-table-column prop="TotalCount" min-width="120px" label="合计记录数量" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <query-dialog ref="queryDialog" @on-search="onSearch" @edit-closed="onClosed" />
    <select-dialog ref="selectDialog" @on-search="onSearch" @on-search2="onSearch2" @on-edit="onEdit" />
    <allgrow-dialog ref="allgrowDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import queryDialog from "./queryDialog";
import selectDialog from "./selectDialog";
import allgrowDialog from "./allgrowDialog";

export default {
  mixins: [listMixin],
  components: { list, queryDialog, selectDialog, allgrowDialog },
  data() {
    return {
      api: require("@/api/gd/common").default,
      queryType: 0,
      params: {},
      params2: [],
    };
  },
  methods: {
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      if(this.queryType == 0) {
        this.api.exportQueryData(this.params).then(() => {
          loading.close();
        });
      } else {
        this.api.exportQueryGroupData(this.params2).then(() => {
          loading.close();
        });
      }
    },
    onExportDetail() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      if(this.queryType == 0) {
        this.api.exportQueryDataDetail(this.params).then(() => {
          loading.close();
        });
      } else {
        this.api.exportQueryGroupDataDetail(this.params2).then(() => {
          loading.close();
        });
      }
    },
    getDataFunc() {
      return new Promise((resolve, reject) => {
        if(this.queryType == 0) {
          var params = this.$commonJs.obj.removeNullKey(this.params);
          this.api.getQueryData(params).then((res) => {
            resolve(res);
          });
        } else {
          this.api.getQueryGroupData(this.params2).then((res) => {
            resolve(res);
          });
        }
      });
    },
    openEdit() {
      this.$refs.queryDialog.open().then((that) => {
        that.getData();
      });
    },
    openSelect() {
      this.$refs.selectDialog.open().then((that) => {
        that.getData();
      });
    },
    openAll(row) {
      this.$refs.allgrowDialog.open().then((that) => {
        that.getData({ TeacherId: row.TeacherId, ...this.params });
      });
    },
    onEdit(data) {
      console.log("编辑", data);
      this.$refs.queryDialog.open().then((that) => {
        that.getData(data);
      });
    },
    onClosed() {
      console.log("关闭");
      this.$refs.selectDialog.getData();
    },
    onSearch(data) {
      this.queryType = 0;
      this.params = data;
      this.$refs.list.getData();
    },
    onSearch2(data) {
      this.queryType = 1;
      this.params2 = data;
      this.$refs.list.getData();
    },
    onReset() {
      this.params = {};
      this.$refs.list.getData();
    },
  },
};
</script>